import { AccountLevel, AccountStatus } from "utils/layout-utils"

export const UserInfo = ({ accountData }: any) => {


    return (
        <>
            <div className="lg:w-[95%] w-full  rounded-b-xl mx-auto bg-[#447aee] px-2 shadow-xl flex flex-wrap items-center ">
                <div className="lg:w-[20%] md:w-[33.33%] w-[50%] min-h-[45px] flex md:flex-row flex-col items-center justify-center md:text-sm text-xs">
                    <span className="font-bold">نام کاربری اکانت :</span>
                    <span className="mt-2 mr-2 text-white md:mt-0">{accountData?.data?.data?.username}</span>
                </div>
                <div className="lg:w-[20%] md:w-[33.33%] w-[50%] min-h-[45px] flex md:flex-row flex-col items-center justify-center md:text-sm text-xs">
                    <span className="font-bold "> سرور اکانت :</span>
                    <span className="mt-2 mr-2 text-white md:mt-0 text-[10px]">{accountData?.data?.data?.server_symbol}</span>
                </div>
                <div className="lg:w-[20%] md:w-[33.33%] w-[50%] min-h-[45px] flex md:flex-row flex-col items-center justify-center md:text-sm text-xs">
                    <span className="font-bold"> پلتفرم :</span>
                    <span className="mt-2 mr-2 text-white md:mt-0">{accountData?.data?.data?.platform}</span>
                </div>
                <div className="lg:w-[20%] md:w-[33.33%] w-[50%] min-h-[45px] flex md:flex-row flex-col items-center justify-center md:text-sm text-xs">
                    <span className="font-bold">مرحله چالش :</span>
                    <span className="mt-2 mr-2 text-white md:mt-0">{AccountLevel(accountData?.data?.data?.level)}</span>
                </div>
                <div className="lg:w-[20%] md:w-[33.33%] w-[50%] min-h-[45px] flex md:flex-row flex-col items-center justify-center md:text-sm text-xs">
                    <span className="font-bold">  وضعیت حساب :</span>
                    <span className={`mt-2 mr-2 text-white md:mt-0 text-[10px] `} style={{ color: AccountStatus(accountData?.data?.data?.status)?.color }} >{AccountStatus(accountData?.data?.data?.status)?.title}</span>
                </div>
            </div>
        </>
    )
}